module.exports = __webpack_public_path__ + "img/06_Screenshot 2025-06-13 at 14.01.45.21c98584.jpg";